import { Axios } from '../utils/axios'
//添加考试
function AddExamination(params) {
  return new Promise((resolve, reject) => {
    Axios.post('/trainAdmin/examinationAdmin',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//添加学校
function AddSchool(params) {
  return new Promise((resolve, reject) => {
    Axios.post('/trainAdmin/trainAdmin',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//添加资源
function AddResources(params) {
  return new Promise((resolve, reject) => {
    Axios.post('/resourcesAdmin/resourcesAdmin',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//添加课程
function AddCourse(params) {
  return new Promise((resolve, reject) => {
    Axios.post('/courseAdmin/course',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//添加章节
function AddCourseChapter(params) {
  return new Promise((resolve, reject) => {
    Axios.post('/courseAdmin/courseChapter',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//添加课时
function AddCourseChapterClass(params) {
  return new Promise((resolve, reject) => {
    Axios.post('/courseAdmin/courseChapterClass',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改资源
function editResources(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/resourcesAdmin/resourcesAdmin',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改课时
function editCourseChapterClass(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/courseAdmin/courseChapterClass',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改章节
function editCourseChapter(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/courseAdmin/courseChapter',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改课程
function EditCourse(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/courseAdmin/course',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改学校
function EditSchool(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/trainAdmin/trainAdmin',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
///courseAdmin/course/updateStatusCourse修改课程状态
function EditStatusCourse(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/courseAdmin/course/updateStatusCourse',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改成绩比例
function UpdatePercentage(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/trainAdmin/trainAdmin/percentage',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//修改考试
function UpdateExamination(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/trainAdmin/examinationAdmin',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//停止考试
function editStatusExamination(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/trainAdmin/examinationAdmin/editStatus',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
//关联课程
function updateTrainCourseId(params) {
  return new Promise((resolve, reject) => {
    Axios.put('/trainAdmin/trainAdmin/updateTrainCourseId',
       params 
    ).then((res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}
export {
  EditStatusCourse,
  AddExamination,
  editStatusExamination,
  UpdateExamination,
  updateTrainCourseId,
  AddSchool,
  UpdatePercentage,
  EditSchool,
  AddResources,
  AddCourse,
  EditCourse,
  AddCourseChapter,
  editCourseChapter,
  AddCourseChapterClass,
  editCourseChapterClass,
  editResources
}


// WEBPACK FOOTER //
// ./src/api/addAndUpadte.js